const SELECTABLE_COLUMNS: string[] = [
  'reporting_category_major.entity_id',
  'reporting_category_minor.entity_id',
];

export { SELECTABLE_COLUMNS };
